import { IS_UK, IS_NA, jewlr_t } from "helpers/application"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

const footerData = () => {
  const is_uk = IS_UK()
  const is_na = IS_NA()

  return [
    {
      links: [
        {
          name: "About Us",
          url: "/about-us",
        },
        {
          name: "Why Choose Jewlr",
          url: "/info/why_choose_jewlr",
        },
        {
          name: "Customer Reviews",
          url: "/reviews",
        },
        {
          name: "Corporate Sales",
          url: "/info/corporate_sales",
        },
        {
          name: "Press",
          url: "/info/press",
        },
        {
          name: "Partnerships",
          url: "/info/partnerships",
        },
        {
          name: "Terms & Conditions",
          url: "/info/terms-conditions",
        },
        {
          name: "Privacy Policy",
          url: "/info/privacy-policy",
        },
        {
          name: "Accessibility Statement",
          url: "/info/accessibility-statement",
        },
        {
          name: "Accessibility Plan",
          url: "/info/accessibility-plan",
        },
        {
          name: "Supply Chain Transparency",
          options: {
            as: "a",
            href:
              "https://assets.jewlr.com/docs/supply-chain-transparency-report-2025.pdf",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
      ],
      title: "COMPANY",
    },
    {
      links: [
        {
          name: `${jewlr_t("terms.Shipping")} Information`,
          url: "/info/shipping_information",
        },
        {
          name: "Returns & Orders",
          url: "/info/returns",
        },
        {
          name: "Warranty Info",
          url: "/info/warranty-information",
        },
        // {
        //   name: "Free Gift",
        //   url: "/info/free_gift_offer",
        // },
        {
          name: "Jewlr Gift Cards",
          url: "/info/gift_cards",
        },
        {
          name: "VIP Rewards",
          url: "/vip-rewards",
        },
        {
          name: "Gift Preview Video",
          show: sl.config.enable_gift_preview_video,
          url: "/info/gift-preview-video",
        },
        {
          name: "Payment Plans",
          show: enableKlarnaCheckout() || is_na,
          url: "/info/payment-plans",
        },
      ],
      title: "ORDERING",
    },
    {
      links: [
        {
          name: "FAQ",
          url: "/helpdesk",
        },
        {
          name: "How It's Made",
          url: "/info/how_its_made",
        },
        {
          name: "Ring Sizing",
          url: "/info/ring_sizing",
        },
        {
          name: "Chains Information",
          url: "/info/chains_information",
        },

        {
          name: "Packaging",
          url: "/info/packaging",
        },
        {
          name: "Hallmark",
          show: is_uk,
          url: "/info/hallmark",
        },
        {
          name: "Dealer's Notice",
          options: {
            as: "a",
            href:
              "https://www.edinburghassayoffice.co.uk/wp-content/uploads/Type-A-Dealers-Notice-EAO.pdf",
            rel: "noopener noreferrer",
            target: "_blank",
          },
          show: is_uk,
        },
        {
          name: "Gemstones",
          url: "/info/gemstones",
        },
        {
          name: "Diamond & 4Cs",
          url: "/info/diamond",
        },
        {
          name: "Blog",
          url: "/blog",
        },
        {
          name: "Watch Information",
          show: sl.config.enable_watches,
          url: "/about-jewlr-watches",
        },
        {
          name: "Watch Sizing",
          show: sl.config.enable_watches,
          url: "/info/watch-sizing",
        },
        {
          name: "Watch Care",
          show: sl.config.enable_watches,
          url: "/info/watch-care",
        },
      ],
      title: "LEARN",
    },
  ]
}

export default footerData
